import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
export var QuestBoxContainer = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement("div", { className: "" + (className ? className : IdStyles.QuestPanel) }, children);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/QuestBoxContainer.tsx
// module id = 2284
// module chunks = 3